import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SharedNotificationListState} from "@shared/components/notification-list/store/shared-notification-list.state";

export const sharedNotificationListSelect = createFeatureSelector<SharedNotificationListState>('sharedNotifications');

export const selectNotificationList = createSelector(
  sharedNotificationListSelect,
  (state: SharedNotificationListState) => state.notificationList
);

export const selectNotificationCount = createSelector(
  sharedNotificationListSelect,
  (state: SharedNotificationListState) => state.notificationList.paging.totalItems
);

export const selectNotificationSettings = createSelector(
  sharedNotificationListSelect,
  (state: SharedNotificationListState) => state.notificationSettings
);

export const selectIsLoading = createSelector(
  sharedNotificationListSelect,
  (state: SharedNotificationListState) => state.isLoading
);


